module.exports = __webpack_public_path__ + "static/media/Honda_main_t.ef98a985.jpg";